import React, { memo } from 'react';
import { useFragment, graphql } from 'react-relay';
import { ff } from '@atlassian/jira-feature-flagging';
import { PriorityInlineEditViewIsEditable } from '@atlassian/jira-issue-field-priority-inline-edit-full';
import type { priority_nativeIssueTable_PriorityCell$key } from '@atlassian/jira-relay/src/__generated__/priority_nativeIssueTable_PriorityCell.graphql';

// eslint-disable-next-line jira/import/no-restricted-paths
import { useLazyLoadEditability } from '../../../../services/lazy-editability-loader';

type Props = {
	fieldRef: priority_nativeIssueTable_PriorityCell$key;
};

export const PriorityCell = memo(({ fieldRef }: Props) => {
	const data = useFragment<priority_nativeIssueTable_PriorityCell$key>(
		graphql`
			fragment priority_nativeIssueTable_PriorityCell on JiraPriorityField
			@argumentDefinitions(isInlineEditingEnabled: { type: "Boolean!" }) {
				id
				lazyIsEditableInIssueView @include(if: $isInlineEditingEnabled)
				...priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef
			}
		`,
		fieldRef,
	);

	// If the property does not exist in fragment data then we know it has been conditionally excluded because inline
	// editing is disabled. In this case we explicitly set isEditable to false to bypass the lazy editability query.
	const isEditable = 'lazyIsEditableInIssueView' in data ? data.lazyIsEditableInIssueView : false;
	useLazyLoadEditability(data.id, isEditable);

	return (
		<PriorityInlineEditViewIsEditable
			spacing={ff('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'default' : undefined}
			editViewPopup={ff('nin-resizable-columns_8z4eo')}
			editViewPopupAlignBlock={ff('nin-resizable-columns_8z4eo') ? 'center' : undefined}
			fragmentRef={data}
			isEditable={isEditable ?? false}
			menuPosition={ff('jsv-one-issue-table-spreadsheet-ui_ygrnf') ? 'fixed' : undefined}
			readViewFitContainerHeight
		/>
	);
});
